import { render, staticRenderFns } from "./SVGPhotoRotateLeft45.vue?vue&type=template&id=004c5ea4&scoped=true&"
import script from "./SVGPhotoRotateLeft45.vue?vue&type=script&lang=js&"
export * from "./SVGPhotoRotateLeft45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c5ea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('004c5ea4')) {
      api.createRecord('004c5ea4', component.options)
    } else {
      api.reload('004c5ea4', component.options)
    }
    module.hot.accept("./SVGPhotoRotateLeft45.vue?vue&type=template&id=004c5ea4&scoped=true&", function () {
      api.rerender('004c5ea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGPhotoRotateLeft45.vue"
export default component.exports